import { render, staticRenderFns } from "./PalettePickerTextEditor.vue?vue&type=template&id=5e36ef7c&"
import script from "./PalettePickerTextEditor.vue?vue&type=script&lang=js&"
export * from "./PalettePickerTextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports